import { gtm } from 'marketing-tracker';
import flowStore from 'src/stores/flowStore';
import { fireQuestionCompletedAction } from 'src/dispatcher';
import tracker from 'src/libs/tracker';
import QuestionView from './view';

class QuestionViewController {
  constructor() {
    this.view = new QuestionView();
    this.view.addCompletedListener(this.onQuestionCompleted);
  }

  destroy() {
    this.view.removeCompletedListener(this.onQuestionCompleted);
  }

  onStateChange() {
    const activeNode = flowStore.getActiveNode();

    tracker.trackBabbelTracker('question:asked', 4, {
      question: activeNode.question.babbel_tracking,
      answer_presentation_id: activeNode.question.answer_presentation_id
    });

    this.view.render(activeNode.question, activeNode.answers, activeNode.getOptions());
  }

  onQuestionCompleted(clickedAnswer) {
    const activeNode = flowStore.getActiveNode();
    const questionAndAnswer = { question: activeNode.question.gtm, answer: clickedAnswer.gtm };

    gtm.trackQuestionAnswered(questionAndAnswer);
    tracker.trackBabbelTracker('question:answered', 5, {
      question: activeNode.question.babbel_tracking,
      answer: clickedAnswer.babbel_tracking,
      answer_presentation_id: activeNode.question.answer_presentation_id,
      display_rank: clickedAnswer.display_rank
    });

    fireQuestionCompletedAction(questionAndAnswer);
  }
}

export default QuestionViewController;
